exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vt-sort[data-v-2d248b32]{cursor:pointer}", ""]);

// exports
